import { render } from "./AdminSignInPage.vue?vue&type=template&id=20d286d9&scoped=true"
import script from "./AdminSignInPage.vue?vue&type=script&lang=js"
export * from "./AdminSignInPage.vue?vue&type=script&lang=js"

import "./AdminSignInPage.vue?vue&type=style&index=0&id=20d286d9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d286d9"]])

export default __exports__